ixModuleRouting("impactx.deliveryinfo", {
    /* Nur in Angular */
    "/deliveryinfolist": {
        template: "<ixa-delivery-info-list></ixa-delivery-info-list>",
        process: "DeliveryInfoList",
        workspace: "shop",
    },
    "/deliveryinfo/view/:id": {
        template: "<ixa-delivery-info-dialog></ixa-delivery-info-dialog>",
        process: "DeliveryInfoList",
        workspace: "shop",
    },
});